export default class EventEmitter {
  static eventListeners = {};

  static emit(eventName, ...data) {
    if (!EventEmitter.eventListeners[eventName]) {
      // No listeners for the event
      return;
    }

    // Invoke all registered event listeners for the event
    EventEmitter.eventListeners[eventName].forEach((listener) => {
      listener(...data);
    });
  }

  static on(eventName, listener) {
    if (!EventEmitter.eventListeners[eventName]) {
      // Create an array for listeners of the event
      EventEmitter.eventListeners[eventName] = [];
    }

    // Add the listener to the event's array
    EventEmitter.eventListeners[eventName].push(listener);
  }

  static once(eventName, listener) {
    const onceWrapper = (...args) => {
      // Invoke the listener
      listener(...args);

      // Remove the listener after it has been invoked
      EventEmitter.off(eventName, onceWrapper);
    };

    // Add the onceWrapper to the event's array
    EventEmitter.on(eventName, onceWrapper);
  }

  static off(eventName, listener) {
    if (!EventEmitter.eventListeners[eventName]) {
      // No listeners for the event
      return;
    }

    if (listener) {
      // Remove the specified listener from the event's array
      EventEmitter.eventListeners[eventName] = EventEmitter.eventListeners[eventName].filter(
        (l) => l !== listener
      );
    } else {
      // Remove all listeners for the event
      EventEmitter.eventListeners[eventName] = [];
    }
  }
}
